import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer>
      <div className="footer-stars-container">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="footer-star"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${0.5 + Math.random() * 2}px`,
              height: `${0.5 + Math.random() * 2}px`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          ></div>
        ))}
      </div>

      <div className="cosmic-nebula footer-nebula"></div>

      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon footer-logo-icon">
                <div className="satellite"></div>
                <div className="ping"></div>
              </div>
              <div className="footer-logo-text">
                Space<span className="text-accent">Pings</span>
              </div>
            </div>
            <p className="footer-tagline">Track the cosmos above you.</p>
            <div className="orbit-decoration">
              <div className="mini-orbit"></div>
              <div className="mini-satellite"></div>
            </div>
          </div>

          <div className="footer-links-column">
            <h3 className="footer-heading">Explore</h3>
            <ul className="footer-links">
              <li>
                <a href="#terminal">How It Works</a>
              </li>
              <li>
                <a href="#snapshot-score">Snapshot Score</a>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
              <li>
                <Link to="/starlink" className="cosmic-link">
                  Starlink Command
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-links-column">
            <h3 className="footer-heading">Resources</h3>
            <ul className="footer-links">
              <li>
                <Link to="/blog">Spacelogs</Link>
              </li>
              <li>
                <Link to="/newsletter/latest">Newsletter</Link>
              </li>
              <li>
                <Link to="/support">Support</Link>
              </li>
              <li>
                <Link to="/community">Community</Link>
              </li>
            </ul>
          </div>

          <div className="footer-links-column">
            <h3 className="footer-heading">Connect</h3>
            <ul className="footer-links">
              <li>
                <a href="mailto:support@spacepings.space">Email</a>
              </li>
              <li>
                <a href="https://twitter.com/spacepings">Twitter</a>
              </li>
              <li>
                <a href="https://instagram.com/spacepings">Instagram</a>
              </li>
              <li>
                <a href="https://facebook.com/spacepings">Facebook</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">© 2025 SpacePings. All rights reserved.</p>
          <div className="footer-legal-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>

      {/* Floating satellite decoration */}
      <div className="floating-satellite">
        <div className="satellite-body"></div>
        <div className="satellite-panels"></div>
      </div>
    </footer>
  );
};

export default Footer;
